import type { LucideIcon } from "lucide-react";
import { Building2, Handshake, Send } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

// A clean "module coming soon" panel for the not-yet-built modules (docs/15 §3).
// Slice 0 wires the nav shell only — real module content lands in later waves.
const ModulePlaceholder = ({
  title,
  icon: Icon,
  blurb,
  wave,
}: {
  title: string;
  icon: LucideIcon;
  blurb: string;
  wave?: string;
}) => (
  <div className="p-2">
    <h1 className="text-xl font-semibold">{title}</h1>
    <div className="text-sm text-muted-foreground mb-4">Module</div>
    <Card>
      <CardContent className="flex flex-col items-center text-center gap-3 py-14">
        <div className="rounded-full bg-muted p-4">
          <Icon className="h-8 w-8 text-muted-foreground" />
        </div>
        <div className="text-lg font-medium">Coming soon</div>
        <p className="max-w-md text-sm text-muted-foreground">{blurb}</p>
        {wave && <Badge variant="outline">{wave}</Badge>}
      </CardContent>
    </Card>
  </div>
);

export const MlsPage = () => (
  <ModulePlaceholder
    title="MLS"
    icon={Building2}
    blurb="Agent-facing deal pipeline (counterparty = listing agent), agent fields, and a feed from the MLS screener. Net-new — a design session comes first."
    wave="Wave 3"
  />
);
MlsPage.path = "/mls";

export const BuyersPage = () => (
  <ModulePlaceholder
    title="Buyers"
    icon={Handshake}
    blurb="Buyer database (buy-box), buyer tags/segments, and call/text-from-CRM comms. Ties into Dispositions for property blasts."
    wave="Wave 3"
  />
);
BuyersPage.path = "/buyers";

export const DispositionsPage = () => (
  <ModulePlaceholder
    title="Dispositions"
    icon={Send}
    blurb="Transaction Management pipeline (New Contract → Marketing to Buyers → Showing → Evaluating Offers → Accepted → Clear to Close), buyer matching, and property-blast campaigns. The Under-Contract handoff signal already feeds this."
    wave="Wave 3 (Stage 4)"
  />
);
DispositionsPage.path = "/dispositions";

export default ModulePlaceholder;
